import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `transactions`,
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const withdraw = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `transactions/withdraw`,
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `transactions/v2/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Updated successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `transactions/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'transactions',
      method: 'get',
      data: args?.data,
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const verifyPayment = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'payment-requests/verify',
      method: 'post',
      data: args?.data,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const loadwallet = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `transactions/v2/load-wallet`,
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Wallet Loaded Successfully',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
export default {
  find,
  list,
  create,
  update,
  withdraw,
  verifyPayment,
  loadwallet,
}
